import client from '../../client/tbInviteCodeClient';
export default class Model {

    public async findPageByWhere(params: any) {
        const result = await client.findPageByWhere(params);
        if (result && result.success === true) {
            return result;
        } else {
            return null;
        }
    }
    public async add(params: any) {
        const result = await client.add(params);
        if (result && result.success === true) {
            return result;
        } else {
            return null;
        }
    }
    public async delete(params: any) {
        const result = await client.delete(params);
        if (result && result.success === true) {
            return result;
        } else {
            return null;
        }
    }
}
